import { Customer } from './../../../models/Customer';
import { EvaluationService } from './../../../services/evaluation.service';
import { element } from 'protractor';
import { Router } from '@angular/router';
import { AuthService } from './../../../services/auth.service';
import { Component, ViewChild, TemplateRef, OnInit, ViewEncapsulation } from '@angular/core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { HeaderService } from '../../../services/header.service';
import { CmsService } from './../../../services/cms.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageModel } from 'src/app/models/LanguageModel';
import { ResourceService } from 'src/app/services/resource.service';
import { CurrencyModel } from 'src/app/models/CurrencyModel';
import { NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { EvaluationParmModel } from 'src/app/models/Evaluation/EvaluationParmModel';
import { EvaluationDomainTemplateScopeEnum } from 'src/app/models/enums/Evaluation/EvaluationEnums';
import { EvaluationSummaryModel } from 'src/app/models/Evaluation/EvaluationSummaryModel';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import  * as uuid from 'uuid';


@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})

export class HeaderComponent implements OnInit {
  

  faBars = faBars;
  languages;
  currencies;
  logo;
  selectedLanguage;
  selectedCurrency;
  loggedIn: boolean = false;
  loggedInCustomer: Customer;
  defaultLang;
  flag;
  supportedLanguages: LanguageModel[];
  supportedCurrency: CurrencyModel[];
  evaluationSummary: EvaluationSummaryModel;

  myTheme;
  profilePicUrl: string;
  paymentFlag: boolean;

  constructor(
    private service: HeaderService,
    public authService: AuthService,
    private router: Router,
    public translateService: TranslateService,
    public resourceService: ResourceService,
    private evaluationService: EvaluationService,
    private attachmentService: AttachmentService,
    config: NgbPopoverConfig,
    private cmsService: CmsService
  ) {

    config.placement = 'bottom';
  }


  get attachmentScopesEnum(){
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login-page');
    this.loggedIn = false;
    this.loggedInCustomer=null;
    this.authService.saveCustomer(null);


  }

  ngOnInit(): void {

    this.resourceService.paymentFlag.subscribe(res =>{
      if(res!=null){
        this.paymentFlag=res;
      }
      else{
        this.paymentFlag=false;
      }
    })

    this.resourceService.supportedLanguages.subscribe(res => {
      this.resourceService.selectedLanguage.subscribe(selectedLang => {
        this.selectedLanguage = selectedLang.id;
        this.supportedLanguages = res;
  
        this.translateService.addLangs(res.map(o => o.id + ''));
        this.translateService.setDefaultLang(this.selectedLanguage + '');
        //const browserLang = this.translateService.getBrowserLang();
        /*      let langModel=this.resourceService.getCachedSelectedLanguage();
             if(langModel!=null){
               this.selectedLanguage=Number(langModel.id);
               this.resourceService.updateSelectedLanguage(langModel);
             }
             else{
               res.forEach(element => {
                 if(element.isoCode2.toLocaleLowerCase()==browserLang.toLocaleLowerCase()){
                   this.selectedLanguage=element.id;
                   this.resourceService.updateSelectedLanguage(element);
                 }
               });
             } */

        this.translateService.use(this.selectedLanguage + '');


      })


    })
    this.resourceService.getLanguages().subscribe(res => {


    });

    this.resourceService.supportedCurrencies.subscribe(res => {


      this.resourceService.selectedCurrency.subscribe(currency => {
        this.selectedCurrency = currency.currencyID;
        this.supportedCurrency = res;
      })


    })


    this.authService.loggedInCustomer.subscribe(res => {

      this.loggedInCustomer = res;

      if (res != null) {
        this.getProfilePic(res.customerID);
        let req: EvaluationParmModel = {
          EvalueeID: res.customerID,
          ScopeID: EvaluationDomainTemplateScopeEnum.RentalToCustomer
        }
        this.evaluationService.getEvaluationSummary(req).subscribe(res => {

          if(res!=null&&res.evaluationLogsDetails!=null&&res.evaluationLogsDetails.length>0){
            this.evaluationSummary = res;
            this.evaluationService.updateCustomerEvaluation(res);
          }


        });
      }

    });


    this.cmsService.contentModel.subscribe(theme => {

      if(theme!=null){
        ;
        // this.myTheme = theme.theme;
        this.logo = theme.theme.logo;
      }
    });



    //this.currencies = this.service.getCurrencies();
    //this.logo = this.service.getLogo();
    //this.selectedLanguage = this.languages[0];
    //this.selectedCurrency = this.currencies[0];
    //this.loggedIn = this.authService.loggedInStatus;

    /* if(this.authService.getToken()!==null){
      this.loggedIn=true;
    }
    else{
      this.loggedIn=false;

    } */



  }


  MyBookings() {
    this.router.navigate(['/My-Bookings']);
  }

  MyProfile() {
    this.router.navigate(['/View-My-Profile']);
  }

  MyFavourits() {
    this.router.navigate(['/My-Favourits']);
  }

  MyNotifications() {
    this.router.navigate(['/My-Notifications']);
  }


  isLoggedIn() {

    if (this.loggedInCustomer == null || Object.keys(this.loggedInCustomer).length === 0) {
      return false;
    }

    return true;
  }
  langChange(val, supportedLanguages: LanguageModel[]) {

    //Todo: Save it in localStorage
    let selectedLang = supportedLanguages.filter(l => l.id == val)[0];
    this.resourceService.updateSelectedLanguage(selectedLang);
    this.resourceService.cachedSelectedLanguage(selectedLang);
    this.selectedLanguage = val;
    this.translateService.use(val);
    location.reload();
  }

  currencyChange(val, supportedCurrency: CurrencyModel[]) {
    let selectedCurrency = supportedCurrency.filter(l => l.currencyID == val)[0];
    this.resourceService.updateٍSelectedCurrency(selectedCurrency);
    this.resourceService.cachedSelectedCurrency(selectedCurrency);
    location.reload();
    //Todo:Cache selected currency
  }

  getProfilePic(customerID: any,appendRandomParam?) {
    // this.attachmentService.imageHandler(customerID, AttachmentScopesEnum.Customer, AttachmentTypeEnum.CustomerIndividualImage).subscribe(res => {
    //   if (res != null) {

    //     this.profilePicUrl = res;
    //   }

    // })
    let url= this.attachmentService.getImageLink(customerID, AttachmentScopesEnum.Customer, AttachmentTypeEnum.CustomerIndividualImage);
    if(appendRandomParam!=null){

    }
    url+='&random='+uuid.v4();
    this.profilePicUrl=url;
  }


  statusIsopen = true;


}
